import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import hasPermission from '../../../../../shared/utils/access-control/has-permission';
import {
  getIsDemoAccount,
  isAgency,
} from '../../../../../shared/utils/user-details';
import { Field } from '../../../../settings/types/field';
import { ProspectSortBy } from '../../../enums/prospect';
import { ProspectAttribute } from '../types';

const prospectSystemAttributes: ProspectAttribute[] = [
  {
    id: 'name',
    label: 'Name',
    isDefault: true,
    isNonRemovable: true,
    sortBy: ProspectSortBy.FirstName,
    isEditable: false,
  },
  {
    id: 'email',
    label: 'Email',
    isDefault: true,
    isNonRemovable: true,
    isEditable: false,
  },
  {
    id: 'jobTitle',
    label: 'Job Title',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'prospectStatus',
    label: 'Latest Status',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'sequenceAssociated',
    label: 'Sequence Associated',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'subSequenceAssociated',
    label: 'Subsequence',
    isEditable: false,
  },
  {
    id: 'prospectOutcomes',
    label: 'Prospect Outcomes',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'prospectTags',
    label: 'Prospect Tags',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'verificationStatus',
    label: 'Email Verification Status',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'emailServiceProvider',
    label: 'Prospect ESP',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'lastContacted',
    label: 'Last Contacted',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'department',
    label: 'Department',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'company',
    label: 'Company',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'companyIndustry',
    label: 'Company Industry',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'industry',
    label: 'Industry',
    isEditable: true,
    isDefault: true,
  },
  {
    id: 'companyWebsite',
    label: 'Company Website',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'prospectOwner',
    label: 'Prospect Owner',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'creationDate',
    label: 'Creation Date',
    isEditable: false,
  },
  {
    id: 'lastUpdated',
    label: 'Last Updated',
    isEditable: false,
  },
  {
    id: 'verificationSubStatus',
    label: 'Email Verification Sub Status',
    isEditable: false,
  },
  {
    id: 'freeEmailAccount',
    label: 'Free Email Account',
    isEditable: false,
  },
  {
    id: 'mxRecord',
    label: 'MX Record',
    isEditable: false,
  },
  {
    id: 'creationSource',
    label: 'Creation Source',
    isEditable: false,
  },
  {
    id: 'numberOfEmailsSent',
    label: 'Number of Emails sent',
    isEditable: false,
  },
  {
    id: 'clientAssociated',
    label: 'Client Associated',
    isEditable: false,
  },
  {
    id: 'linkedIn',
    label: 'LinkedIn',
    isEditable: true,
  },
  {
    id: 'phoneNumber',
    label: 'Phone Number',
    isEditable: true,
  },
  {
    id: 'experience',
    label: 'Experience',
    isEditable: true,
  },
  {
    id: 'twitter',
    label: 'Twitter',
    isEditable: true,
  },
  {
    id: 'facebook',
    label: 'Facebook',
    isEditable: true,
  },
  {
    id: 'city',
    label: 'City',
    isEditable: true,
  },
  {
    id: 'state',
    label: 'State',
    isEditable: true,
  },
  {
    id: 'country',
    label: 'Country',
    isEditable: true,
  },
  {
    id: 'companyLinkedIn',
    label: 'Company LinkedIn',
    isEditable: true,
  },
  {
    id: 'companyPhone',
    label: 'Company Phone',
    isEditable: true,
  },
  {
    id: 'companyDomain',
    label: 'Company Domain',
    isEditable: true,
  },
  {
    id: 'companySize',
    label: 'Company Size',
    isEditable: true,
  },
  {
    id: 'companyRevenue',
    label: 'Company Revenue',
    isEditable: true,
  },
  {
    id: 'companyFoundedYear',
    label: 'Company Founded Year',
    isEditable: true,
  },
  {
    id: 'numberOfOpens',
    label: 'Number of Opens',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'numberOfClicks',
    label: 'Number of Clicks',
    isDefault: true,
    isEditable: false,
  },
  {
    id: 'recentlyOpenDate',
    label: 'Recently open date',
    isEditable: false,
  },
  {
    id: 'recentlyClickDate',
    label: 'Recently click date',
    isEditable: false,
  },
  {
    id: 'recentlyReplyDate',
    label: 'Recently reply date',
    isEditable: false,
  },
  {
    id: 'currency',
    label: 'Deal Value',
    // isDefault: true,
    isEditable: true,
  },
  {
    id: 'date',
    label: 'Closing Date',
    // isDefault: true,
    isEditable: true,
  },
  {
    id: 'domain(AI)',
    label: 'Domain (AI)',
    isEditable: false,
    isDefault: true,
    onlyForDemo: true,
  },
  {
    id: 'companyType(AI)',
    label: 'Company Type (AI)',
    isEditable: false,
    isDefault: true,
    onlyForDemo: true,
  },
  {
    id: 'managementLevel',
    label: 'Person’s Seniority Level',
    isEditable: true,
  },
  {
    id: 'decisionMaker',
    label: 'Decision Role',
    isEditable: false,
  },
  {
    id: 'currentCompanyExperience',
    label: 'Current Company Experience (In Months)',
    isEditable: true,
  },
  {
    id: 'tenureInCurrentRole',
    label: 'Tenure In Current Role (In Months)',
    isEditable: true,
  },
  {
    id: 'projectedSalary',
    label: 'Projected Salary',
    isEditable: true,
  },
  {
    id: 'linkedInFollowers',
    label: 'LinkedIn Followers',
    isEditable: true,
  },
  {
    id: 'inB2B',
    label: 'Is B2B',
    isEditable: false,
  },
  {
    id: 'companyHQLocation',
    label: 'Company HQ Location',
    isEditable: true,
  },
  {
    id: 'fundingAmount',
    label: 'Company’s Latest Funding Amount',
    isEditable: true,
  },
  {
    id: 'lastFundingDate',
    label: 'Company’s Latest Funding Date',
    isEditable: false,
  },
  {
    id: 'linkedInHeadline',
    label: 'Profile Headline',
    isEditable: true,
  },
  {
    id: 'linkedInProfileSummary',
    label: 'LinkedIn Profile Summary',
    isEditable: true,
  },
  {
    id: 'JobChangedOn',
    label: 'Job Changed Before (In Months)',
    isEditable: true,
  },
];

const kanbanProspectSystemAttributes: ProspectAttribute[] = [
  {
    id: 'name',
    label: 'Prospect Name',
    isDefault: true,
    // isNonRemovable: true,
    // sortBy: ProspectSortBy.FirstName,
    isEditable: true,
  },
  {
    id: 'email',
    label: 'Email',
    isDefault: false,
    // isNonRemovable: true,
    isEditable: true,
  },
  {
    id: 'jobTitle',
    label: 'Job Title',
    isDefault: false,
    isEditable: true,
  },
  {
    id: 'prospectStatus',
    label: 'Latest Status',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'sequenceAssociated',
    label: 'Sequence Associated',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'subSequenceAssociated',
    label: 'Subsequence',
    isEditable: false,
  },
  {
    id: 'prospectOutcomes',
    label: 'Prospect Outcomes',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'prospectTags',
    label: 'Prospect Tags',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'verificationStatus',
    label: 'Email Verification Status',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'emailServiceProvider',
    label: 'Prospect ESP',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'lastContacted',
    label: 'Last Contacted',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'department',
    label: 'Department',
    isDefault: false,
    isEditable: true,
  },
  {
    id: 'company',
    label: 'Company Name',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'companyIndustry',
    label: 'Company Industry',
    isDefault: false,
    isEditable: true,
  },
  {
    id: 'industry',
    label: 'Industry',
    isEditable: false,
    isDefault: false,
  },
  {
    id: 'companyWebsite',
    label: 'Company Website',
    isDefault: false,
    isEditable: true,
  },
  {
    id: 'prospectOwner',
    label: 'Prospect Owner',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'creationDate',
    label: 'Creation Date',
    isEditable: false,
  },
  {
    id: 'lastUpdated',
    label: 'Last Updated',
    isEditable: false,
  },
  {
    id: 'verificationSubStatus',
    label: 'Email Verification Sub Status',
    isEditable: false,
  },
  {
    id: 'freeEmailAccount',
    label: 'Free Email Account',
    isEditable: false,
  },
  {
    id: 'mxRecord',
    label: 'MX Record',
    isEditable: false,
  },
  {
    id: 'creationSource',
    label: 'Creation Source',
    isEditable: false,
  },
  {
    id: 'numberOfEmailsSent',
    label: 'Number of Emails sent',
    isEditable: false,
  },
  {
    id: 'clientAssociated',
    label: 'Client Associated',
    isEditable: false,
  },
  {
    id: 'linkedIn',
    label: 'LinkedIn',
    isEditable: true,
  },
  {
    id: 'phoneNumber',
    label: 'Phone Number',
    isEditable: true,
  },
  {
    id: 'experience',
    label: 'Experience',
    isEditable: true,
  },
  {
    id: 'twitter',
    label: 'Twitter',
    isEditable: true,
  },
  {
    id: 'facebook',
    label: 'Facebook',
    isEditable: true,
  },
  {
    id: 'city',
    label: 'City',
    isEditable: true,
  },
  {
    id: 'state',
    label: 'State',
    isEditable: true,
  },
  {
    id: 'country',
    label: 'Country',
    isEditable: true,
  },
  {
    id: 'companyLinkedIn',
    label: 'Company LinkedIn',
    isEditable: true,
  },
  {
    id: 'companyPhone',
    label: 'Company Phone',
    isEditable: true,
  },
  {
    id: 'companyDomain',
    label: 'Company Domain',
    isEditable: true,
  },
  {
    id: 'companySize',
    label: 'Company Size',
    isEditable: true,
  },
  {
    id: 'companyRevenue',
    label: 'Company Revenue',
    isEditable: true,
  },
  {
    id: 'companyFoundedYear',
    label: 'Company Founded Year',
    isEditable: true,
  },
  {
    id: 'numberOfOpens',
    label: 'Number of Opens',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'numberOfClicks',
    label: 'Number of Clicks',
    isDefault: false,
    isEditable: false,
  },
  {
    id: 'recentlyOpenDate',
    label: 'Recently open date',
    isEditable: false,
  },
  {
    id: 'recentlyClickDate',
    label: 'Recently click date',
    isEditable: false,
  },
  {
    id: 'recentlyReplyDate',
    label: 'Recently reply date',
    isEditable: false,
  },
  {
    id: 'currency',
    label: 'Deal Value',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'date',
    label: 'Closing Date',
    isDefault: true,
    isEditable: true,
  },
  {
    id: 'domain(AI)',
    label: 'Domain (AI)',
    isEditable: false,
    isDefault: true,
    onlyForDemo: true,
  },
  {
    id: 'companyType(AI)',
    label: 'Company Type (AI)',
    isEditable: false,
    isDefault: true,
    onlyForDemo: true,
  },
  {
    id: 'managementLevel',
    label: 'Person’s Seniority Level',
    isEditable: true,
  },
  {
    id: 'decisionMaker',
    label: 'Decision Role',
    isEditable: false,
  },
  {
    id: 'currentCompanyExperience',
    label: 'Current Company Experience (In Months)',
    isEditable: true,
  },
  {
    id: 'tenureInCurrentRole',
    label: 'Tenure In Current Role (In Months)',
    isEditable: true,
  },
  {
    id: 'projectedSalary',
    label: 'Projected Salary',
    isEditable: true,
  },
  {
    id: 'linkedInFollowers',
    label: 'LinkedIn Followers',
    isEditable: true,
  },
  {
    id: 'inB2B',
    label: 'Is B2B',
    isEditable: false,
  },
  {
    id: 'companyHQLocation',
    label: 'Company HQ Location',
    isEditable: true,
  },
  {
    id: 'fundingAmount',
    label: 'Company’s Latest Funding Amount',
    isEditable: true,
  },
  {
    id: 'lastFundingDate',
    label: 'Company’s Latest Funding Date',
    isEditable: false,
  },
  {
    id: 'linkedInHeadline',
    label: 'Profile Headline',
    isEditable: true,
  },
  {
    id: 'linkedInProfileSummary',
    label: 'LinkedIn Profile Summary',
    isEditable: true,
  },
  {
    id: 'JobChangedOn',
    label: 'Job Changed Before (In Months)',
    isEditable: true,
  },
];

const skipSystemAttributes = [
  'name',
  'email',
  'prospectStatus',
  'sequenceAssociated',
  'prospectOutcomes',
  'prospectTags',
  'lastContacted',
  'prospectOwner',
  'creationDate',
  'lastUpdated',
  'sequenceAssociated',
  'subSequenceAssociated',
  'verificationStatus',
  'verificationSubStatus',
  'mxRecord',
  'freeEmailAccount',
  'emailServiceProvider',
  'creationSource',
  'numberOfEmailsSent',
  'clientAssociated',
  'numberOfOpens',
  'numberOfClicks',
  'recentlyOpenDate',
  'recentlyClickDate',
  'recentlyReplyDate',
];

export const getProspectSystemAttributes = (fields: Field[]) =>
  prospectSystemAttributes
    .map((attribute) => {
      // Check if the field is an API field and update the id based on fields
      const fieldFromApi = fields.find(
        (field) => field?.label === attribute?.label,
      );

      if (attribute.onlyForDemo && !getIsDemoAccount()) {
        return null;
      }

      // Remove From local storage when user come first time
      if (!getIsDemoAccount()) {
        const stored = localStorage?.getItem('prospectTableColumns');
        if (stored) {
          try {
            const parsed = JSON?.parse(stored);

            const cleaned = parsed?.filter(
              (item: { id: string }) =>
                item?.id !== 'domain(AI)' && item?.id !== 'companyType(AI)',
            );

            if (cleaned?.length !== parsed?.length) {
              localStorage?.setItem(
                'prospectTableColumns',
                JSON?.stringify(cleaned),
              );
            }
          } catch (e) {
            console.error(
              'Failed to parse prospectTableColumns from localStorage',
              e,
            );
          }
        }
      }

      // Check if the field label exists in skipSystemAttributes array
      if (skipSystemAttributes.includes(attribute.id)) {
        // Check permission for client associated column
        if (attribute.id === 'clientAssociated') {
          const isClientAssociatedVisible =
            hasPermission(Permissions.CLIENT_READ) && isAgency();

          if (isClientAssociatedVisible) {
            return attribute;
          }

          return null;
        }

        return attribute;
      }

      if (fieldFromApi) {
        return {
          ...attribute,
          id: fieldFromApi.id.toString(),
          fieldType: fieldFromApi.fieldType,
          isEditable: attribute.isEditable,
        };
      }

      return attribute;
    })
    .filter((item) => item !== null);

export const getKanbanProspectSystemAttributes = (fields: Field[]) =>
  kanbanProspectSystemAttributes
    .map((attribute) => {
      // Check if the field is an API field and update the id based on fields
      const fieldFromApi = fields?.find(
        (field) => field?.label === attribute?.label,
      );

      if (attribute.onlyForDemo && !getIsDemoAccount()) {
        return null;
      }

      // Remove From local storage when user come first time
      if (!getIsDemoAccount()) {
        const stored = localStorage?.getItem('prospectTableColumns');
        if (stored) {
          try {
            const parsed = JSON?.parse(stored);

            const cleaned = parsed?.filter(
              (item: { id: string }) =>
                item?.id !== 'domain(AI)' && item?.id !== 'companyType(AI)',
            );

            if (cleaned?.length !== parsed?.length) {
              localStorage?.setItem(
                'prospectTableColumns',
                JSON?.stringify(cleaned),
              );
            }
          } catch (e) {
            console.error(
              'Failed to parse prospectTableColumns from localStorage',
              e,
            );
          }
        }
      }

      // Check if the field label exists in skipSystemAttributes array
      if (skipSystemAttributes.includes(attribute.id)) {
        // Check permission for client associated column
        if (attribute.id === 'clientAssociated') {
          const isClientAssociatedVisible =
            hasPermission(Permissions.CLIENT_READ) && isAgency();

          if (isClientAssociatedVisible) {
            return attribute;
          }

          return null;
        }

        return attribute;
      }

      if (fieldFromApi) {
        return {
          ...attribute,
          id: fieldFromApi?.id?.toString(),
          fieldType: fieldFromApi?.fieldType,
          isEditable: attribute?.isEditable,
          fieldMetadata: fieldFromApi?.fieldMetadata,
        };
      }

      return attribute;
    })
    .filter((item) => item !== null);
